var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { MatrixCellWrapperViewModel } from "survey-creator-core";
import { attachKey2click, ReactElementFactory, SvgIcon } from "survey-react-ui";
import { CreatorModelElement } from "./ModelElement";
var MatrixCellAdornerComponent = /** @class */ (function (_super) {
    __extends(MatrixCellAdornerComponent, _super);
    function MatrixCellAdornerComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MatrixCellAdornerComponent.prototype.createModel = function (props) {
        var _a;
        var data = props.componentData;
        var prevIsSelected = false;
        if (!!this.model) {
            prevIsSelected = this.model.isSelected;
        }
        this.model = new MatrixCellWrapperViewModel(data.creator, data.element, data.question, data.row, data.column || ((_a = data.element.cell) === null || _a === void 0 ? void 0 : _a.column));
        this.model.isSelected = prevIsSelected;
    };
    MatrixCellAdornerComponent.prototype.getUpdatedModelProps = function () {
        return ["componentData"];
    };
    MatrixCellAdornerComponent.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a, _b;
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        var data = this.props.componentData;
        this.model.templateData = data.element;
        this.model.row = data.row;
        this.model.column = data.column || ((_b = (_a = data.element) === null || _a === void 0 ? void 0 : _a.cell) === null || _b === void 0 ? void 0 : _b.column);
        this.model.question = data.question;
    };
    MatrixCellAdornerComponent.prototype.getStateElement = function () {
        return this.model;
    };
    MatrixCellAdornerComponent.prototype.render = function () {
        var _this = this;
        var controls = null;
        if (!!this.model.isSupportCellEditor) {
            controls = React.createElement("div", { className: "svc-matrix-cell__question-controls" }, attachKey2click(React.createElement("span", { className: "svc-matrix-cell__question-controls-button svc-context-button", onClick: function (event) { return _this.model.editQuestion(_this.model, event); } },
                React.createElement(SvgIcon, { size: "auto", iconName: "icon-edit" }))));
        }
        return (React.createElement("div", { className: "svc-matrix-cell", tabIndex: -1, key: this.props.element.key, onClick: function (e) { return !_this.props.question && _this.model.selectContext(_this.model, e); }, onMouseOut: function (e) { return _this.model.hover(e.nativeEvent, e.currentTarget); }, onMouseOver: function (e) { return _this.model.hover(e.nativeEvent, e.currentTarget); } },
            React.createElement("div", { className: "svc-matrix-cell--selected" + (this.model.isSelected ? " svc-visible" : "") }),
            this.props.element,
            controls));
    };
    return MatrixCellAdornerComponent;
}(CreatorModelElement));
export { MatrixCellAdornerComponent };
ReactElementFactory.Instance.registerElement("svc-matrix-cell", function (props) {
    return React.createElement(MatrixCellAdornerComponent, props);
});
